import { client } from 'shared';

export function providerReviewList() {
    return client('api/provider-review/eligible-for-review/');
}
